export enum PtaExistingRequestsEnum {
    MODULE_ACCESS = 'View',
    FILTERS_ACCESS = 'NA',
    TABLEDATA_ACCESS = 'NA',
    PTA_REQUEST_DETAILS_ACCESS = 'NA',
    PTA_REQUEST_DETAILS_PREMIUMCHECKLIST_LINK_ACCESS = 'PTA_Request_Details_PremiumCheckList_Link'
}